import { useEffect } from "react"
import { useParams } from "react-router-dom";
import { rejectCollabratorRequest } from "../../actions/collabratorAction";
import LoadingScreen from "../CommonComponents/LoadingScreen";


function RejectCollabratorRequest(){
    const params = useParams();
    useEffect(()=>{
        const ownerId = params.userId;
        const wallId = params.wallId;
        rejectCollabratorRequest(ownerId,wallId).then((response)=>{
             window.location.href="https://taggbox.com/invitation-reject/";
        }).catch(ex=>{
            localStorage.clear();
            window.location.href="https://taggbox.com/invitation-reject/";
        });
    },[])
    return <LoadingScreen/>
}

export default RejectCollabratorRequest;